import { render, staticRenderFns } from "./Rice.vue?vue&type=template&id=81ae058a&scoped=true"
import script from "./Rice.vue?vue&type=script&lang=js"
export * from "./Rice.vue?vue&type=script&lang=js"
import style0 from "./Rice.vue?vue&type=style&index=0&id=81ae058a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ae058a",
  null
  
)

export default component.exports